import { useEffect, useState } from "react";
import { Phone } from "lucide-react";
import { site } from "@/config/site";
import { WhatsAppIcon } from "./CtaButtons";

export const StickyBar = () => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <div className="hidden md:flex fixed bottom-6 right-6 z-50 flex-col gap-3" data-testid="floating-buttons">
        <a
          href={site.whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="WhatsApp ile iletişim"
          className="relative flex h-14 w-14 items-center justify-center rounded-full bg-whatsapp text-white shadow-2xl hover:scale-110 transition-transform animate-float"
          data-testid="floating-whatsapp"
        >
          <WhatsAppIcon className="w-7 h-7" />
          <span className="absolute -top-0.5 -right-0.5 flex h-3 w-3"><span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-whatsapp opacity-75" /><span className="relative inline-flex h-3 w-3 rounded-full bg-whatsapp border-2 border-white" /></span>
        </a>
        <a href={site.phoneTel} aria-label="Telefon ile ara" className="flex h-14 w-14 items-center justify-center rounded-full bg-emerald text-white shadow-2xl hover:scale-110 transition-transform" data-testid="floating-call">
          <Phone size={24} aria-hidden="true" />
        </a>
      </div>

      <div
        role="region"
        aria-label="Hızlı randevu çubuğu"
        className={`fixed bottom-0 inset-x-0 z-40 transition-transform duration-500 ${scrolled ? "md:translate-y-0" : "md:translate-y-full"}`}
        data-testid="sticky-cta-bar"
      >
        <div className="mx-auto max-w-5xl px-3 pb-3 md:pb-4">
          <div className="relative overflow-hidden rounded-2xl border border-gold/50 bg-gradient-to-r from-emerald-deep via-emerald to-emerald-deep shadow-[0_20px_50px_rgba(0,0,0,0.45)]">
            <div className="absolute top-0 inset-x-0 h-[2px] bg-gradient-to-r from-transparent via-gold to-transparent" aria-hidden="true" />
            <div className="flex items-center gap-3 px-3 py-3 md:px-5 md:py-4">
              <div className="hidden sm:flex flex-col leading-tight min-w-0">
                <span className="text-[10px] uppercase tracking-widest text-gold font-semibold">Hemen Randevu</span>
                <span className="text-xs md:text-sm font-bold text-white truncate">{site.openingHours.text}</span>
              </div>
              <div className="flex flex-1 items-center justify-end gap-2">
                <a href={site.phoneTel} className="btn btn-gold btn-sm flex-1 sm:flex-none" data-testid="sticky-call">
                  <Phone size={16} aria-hidden="true" /> Hemen Ara
                </a>
                <a href={site.whatsappUrl} target="_blank" rel="noopener noreferrer" className="btn btn-whatsapp btn-sm flex-1 sm:flex-none" data-testid="sticky-whatsapp">
                  <WhatsAppIcon className="w-4 h-4" /> WhatsApp'tan Randevu
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
